import React from 'react';
import styled from 'styled-components';

import { Modal, Backdrop, Fade, Typography, LinearProgress } from '@material-ui/core/';

/* eslint-disable indent */
const RootBackdrop = styled(Modal)`
	display: flex;
	align-items: center;
	justify-content: center;

	.backdrop {
		padding: 40px;
		background-color: ${(props) => props.theme.palette.blocks.cardWrapper.background};
		text-align: center;

		.backdrop__text {
			h6 {
				font-weight: bold;
				text-transform: uppercase;
				margin: 0 0 20px 0;
			}
		}

		.backdrop__loading-bar {
			margin-top: 20px;

			.MuiLinearProgress-root,
			.MuiLinearProgress-bar {
				height: 10px;
				border-radius: 5px;
			}

			.MuiLinearProgress-colorPrimary {
				background-color: ${(props) =>
					props.theme.palette.progressBar.backgroundColor};
			}

			.MuiLinearProgress-barColorPrimary {
				background-color: ${(props) =>
					props.theme.palette.progressBar.progressColor};
			}
		}
	}

	.MuiBackdrop-root {
		background-color: rgba(0, 0, 0, 0.8);
		pointer-events: none;
	}
`;

const ModalLoadingScreen = ({ open, headline, subtext, loadingProgress }) => (
	<RootBackdrop
		aria-labelledby="transition-modal-title"
		aria-describedby="transition-modal-description"
		open={open}
		closeAfterTransition
		BackdropComponent={Backdrop}
		BackdropProps={{
			timeout: 600,
		}}
	>
		<Fade in={open}>
			<div className="backdrop">
				<div className="backdrop__text">
					<Typography variant="h6">{headline}</Typography>
					<Typography variant="body2">{subtext}</Typography>
				</div>
				<div className="backdrop__loading-bar">
					<LinearProgress
						className="DataLoadingbar"
						variant="determinate"
						value={loadingProgress}
					/>
				</div>
			</div>
		</Fade>
	</RootBackdrop>
);

export default ModalLoadingScreen;
